// we were storing some keys in localStorage in the past and we don't want them around
// anymore because they may contain some sensitive information

import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";

const keysToCleanUp = ["token"];

keysToCleanUp.forEach((key) => {
  if (localStorage.getItem(key)) {
    GlamCornerCore.bus.broadcast(MainWebsiteEvents.CleanUpStorageKey, { key });
    localStorage.removeItem(key);
  }
});
